import useRealtimeChannel from "@/hooks/useRealtimeChannel";

export default function useAdminRealtime({ enabled, onAdminUpdate, onUnreadStateUpdate }) {
  const token = typeof window !== "undefined" ? localStorage.getItem("auth_token") : null;

  useRealtimeChannel({
    enabled,
    path: "/admin",
    token,
    onMessage: (payload) => {
      if (payload?.type === "admin_update") {
        onAdminUpdate?.(payload);
      }
      if (payload?.type === "admin_unread_state") {
        onUnreadStateUpdate?.(payload);
      }
    },
  });
}
